module.exports = __webpack_public_path__ + "static/media/ag-shop1.154c8caa.jpg";